import angular from 'angular';
import assetFinanceLoanFacility from './assetFinanceLoanFacility';

export default angular
  .module('components.assetFinanceLoanFacility', [])
  .component('assetFinanceLoanFacility', assetFinanceLoanFacility).name;
